import r2Module from "./r2Module"
import server from "../server"

r2Module.service("r2SystemVersionService", ["$http", "$q", "$localStorage", "authenticationService", "versionService",
    function ($http, $q, $localStorage, authenticationService, versionService) {

        var localVersionPromise = null

        this.getLocalVersion = () => {
            if (localVersionPromise) return localVersionPromise
            if (!authenticationService.isAuthenticated()) return $q.reject()

            localVersionPromise = $http.get(server.getServiceUrl("semantic-version")).then(res => res.data)
            return localVersionPromise
        }

        this.getTdnLinkForCurrentVersion = () => {
            return $q.all([
                this.getLocalVersion(),
                versionService.getRemoteVersionInfo()
            ]).then(([localData, remoteData]) => {
                const currentBaseVersion = localData.version.split(".").slice(0, 3).join(".")
                const latest = remoteData.latest
                const history = remoteData.versions || {}
                if (currentBaseVersion === latest.version) {
                    return latest.tdnLink
                }
                const historicEntry = history[currentBaseVersion]
                if (historicEntry && historicEntry.tdnLink) {
                    return historicEntry.tdnLink
                }
                return latest.tdnLink
            })
        }
    }])